<template>
  <div class="municipalities-selector-container">
    <label
      for="municipalitiesSearchInput"
      class="form-label"
    >
      {{ capitalizeFirstLetter($tc('words.municipality', 2)) }}
    </label>
    <MunicipalitiesINSEEList
      :init-values="municipalities"
      v-on="$listeners"
    />
    <MunicipalitiesINSEESearch
      :init-values="municipalities"
    />
    <div
      class="form-check"
      style="margin: 1.5rem 0 1rem;"
    >
      <input
        id="selectAllCheck"
        v-model="selectAll"
        class="form-check-input"
        type="checkbox"
        value=""
      >
      <label
        class="form-check-label"
        for="selectAllCheck"
      >
        {{ $t('words.selectDeselectAll') }}
      </label>
    </div>
    <div id="municipalities-searchbar">
      <input
        v-model="searchQuery"
        v-sanitize
        class="search-table"
        type="search"
        :placeholder="`${capitalizeFirstLetter($t('words.search'))} ...`"
      >
    </div>
    <ul class="municipalities-list list-group">
      <MunicipalitiesSelectorItem
        v-for="municipality of selectedFirstFilteredMunicipalities"
        :key="`municipality-item-${municipality.insee}`"
        :municipality="municipality"
        :select-all="selectAll"
      />
    </ul>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

import MunicipalitiesINSEEList from '@/app/jurisdiction/components/Municipalities/MunicipalitiesINSEEList.vue';
import MunicipalitiesINSEESearch from '@/app/jurisdiction/components/Municipalities/MunicipalitiesINSEESearch.vue';
import MunicipalitiesSelectorItem from '@/app/jurisdiction/components/Municipalities/MunicipalitiesSelectorItem.vue';

export default {
  name: 'MunicipalitiesSearch',

  components: {
    MunicipalitiesINSEEList,
    MunicipalitiesINSEESearch,
    MunicipalitiesSelectorItem
  },

  props: {
    municipalities: {
      type: Array,
      default: () => { return []; }
    },
  },

  data() {
    return {
      selectAll: false,
      searchQuery: null,
      filteredMunicipalities: []
    };
  },

  computed: {
    ...mapState('municipalities', [
      'municipalitiesList',
      'selectedMunicipalities'
    ]),
    ...mapGetters('municipalities', [
      'areAllMunicipalitiesSelected'
    ]),

    selectedFirstFilteredMunicipalities() {
      const list = [...this.filteredMunicipalities];
      const selected = [...this.selectedMunicipalities].sort((a, b) => b.displayName.localeCompare(a.displayName));
      const sorted = list.sort((a, b) => {
        return selected.findIndex(el => el.insee === b.insee) - selected.findIndex(el => el.insee === a.insee) ||
          a.displayName.localeCompare(b.displayName);
      });
      return sorted;
    }
  },

  watch: {
    municipalitiesList: {
      deep: true,
      handler(newValue) {
        this.filteredMunicipalities = newValue;
      }
    },
    areAllMunicipalitiesSelected(newValue) {
      this.selectAll = newValue;
    },
    async selectAll(newValue) {
      this.$emit('loading', true);
      if (newValue && !this.areAllMunicipalitiesSelected) {
        await this.SELECT_ALL_MUNICIPALITIES();
      } else if (!newValue && this.areAllMunicipalitiesSelected) {
        await this.DESELECT_ALL_MUNICIPALITIES();
      }
      this.$emit('loading', false);
    },
    searchQuery(newValue) {
      this.filteredMunicipalities = this.municipalitiesList.filter(el => {
        if (el.displayName.toLowerCase().includes(newValue.toLowerCase())) {
          return el;
        }
      });
    }
  },

  created() {
    this.filteredMunicipalities = this.municipalitiesList;
  },

  methods: {
    ...mapActions('municipalities', [
      'SELECT_ALL_MUNICIPALITIES',
      'DESELECT_ALL_MUNICIPALITIES'
    ]),
    sortSelectedsFirst(list) {
      const sorted = [...list.sort((a, b) => {
        return this.selectedMunicipalities.findIndex(el => el.insee === a.insee) -
          this.selectedMunicipalities.findIndex(el => el.insee === b.insee);
      })];
      return sorted;
    }
  }
};
</script>

<style lang="less" scoped>
.multiselect__tags {
  white-space: normal;
  .multiselect__input {
    width: fit-content !important;
  }
}
.form-check-input  {
  margin-left: -1.25rem;
}
#municipalities-searchbar {
  margin-bottom: 1rem;
}
.municipalities-list {
  max-height: 15.5rem;
  overflow-y: auto;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
.form-label {
  margin-bottom: 0.25rem;
}
</style>